export default {
  setCashRegisterOperations(state, payload) {
    state.cashRegisterOperations = payload;
  }
}
